import { loadOptions } from '../../versa/formset.js';

/** Status do Inventário V2 (inventory_sessions) — não confundir com inventário legado. */
export default function (...args)
{
	return {
		options: [
			{ value: '10', label: 'Criado' },
			{ value: '20', label: 'Congelado' },
			{ value: '30', label: 'Em contagem' },
			{ value: '40', label: 'Pronto p/ fechar' },
			{ value: '50', label: 'Fechado' },
			{ value: '60', label: 'Cancelado' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}
